import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { satismeterCampaign: String, satismeterKey: String, user: Object }
  }

  connect() {
    if (this.satismeterKeyValue === "" || this.satismeterCampaignValue === "") {
      return
    }

    window.satismeter = window.satismeter || function() {
      (window.satismeter.q = window.satismeter.q || []).push(arguments)
    }

    window.satismeter.l = 1 * new Date()

    var script = document.createElement("script")
    var parent = document.getElementsByTagName("script")[0].parentNode

    script.async = 1
    script.src = "https://app.satismeter.com/js"
    parent.appendChild(script)

    let satismeterParams = {
      embed: true,
      language: i18n.locale,
      event: "Uninstalled extension",
      writeKey: this.satismeterKeyValue,
      campaign: this.satismeterCampaignValue,
      parent: document.getElementById("survey-container")
    }

    if (this.userValue.id !== null) {
      satismeterParams.userId = this.userValue.id
      satismeterParams.traits = {
        name: this.userValue.name,
        email: this.userValue.email,
        createdAt: this.userValue.created_at
      }
    }

    satismeter("track", satismeterParams)
  }
}
